export type TemplateFile = {
  type: "pptx";
  id: string;
  name: string;
  size?: number;
  eTag?: string;
  lastModifiedDateTime?: string;
  path?: string;
};

export type TemplateFolder = {
  type: "folder";
  name: string;
  path: string;
  children: TemplateFolder[];
  files: TemplateFile[];
  truncated?: boolean;
};

export type TemplateLinks = {
  id: string;
  name: string;
  size?: number;
  eTag?: string;
  lastModifiedDateTime?: string;
  /** Short-lived pre-authenticated SharePoint URL for the .pptx bytes. */
  downloadUrl: string;
  /** Short-lived pre-authenticated URL for the server-rendered PDF, if available. */
  pdfUrl: string | null;
  expiresInSeconds: number;
};

export type SlideInfo = {
  slideNumber: number;
  /** Format expected by insertSlidesFromBase64: "<slideId>#<creationId>". */
  sourceSlideId: string;
  title: string;
};

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly correlationId?: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}
